import { render, staticRenderFns } from "./journeyOptionEditor.vue?vue&type=template&id=8848acf2&scoped=true&"
import script from "./journeyOptionEditor.vue?vue&type=script&lang=js&"
export * from "./journeyOptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./journeyOptionEditor.vue?vue&type=style&index=0&id=8848acf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8848acf2",
  null
  
)

export default component.exports